export const getLegacyLink = (fields: Record<string, unknown>): string => {
  if (typeof fields.link === 'string') return fields.link.trim();
  if (typeof fields.imageLink === 'string') return fields.imageLink.trim();

  return '';
};
